import React, { useEffect/*, useState */} from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import FlagstoneTheme from '../../config/flagstoneTheme';
import { Document, Page, pdfjs } from "react-pdf";

export default function PDFDialog(props) {
    const classes = useStyles();

    useEffect(() => {
        pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    }, [props.dialogOpen]);


    let pdfFileName = "Helpfile";
    let numberOfPages = 9;
 
    return (

        <Dialog className={classes.dialogContainer}
            open={props.dialogOpen}
            onClose={props.closeDialog}
            //PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
        >{props.dialogOpen && pdfFileName !== ""?
            <Document
                file={process.env.PUBLIC_URL + '/helpfiles/' + pdfFileName + '.pdf'}
                options={{ workerSrc: "/pdf.worker.js" }}
                className={classes.document}
            // onLoadSuccess={onDocumentLoadSuccess}
            >
                {Array.from(new Array(numberOfPages), (el, index) => (
                    <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                ))}
            </Document> : <div className = {classes.noDoc}>Geen helpfile aanwezig</div>}
            <DialogActions>
                <div className={classes.buttons}>
                    <Button className={classes.okButton} autoFocus onClick={props.closeDialog}>
                        OK
                 </Button>
                </div>
            </DialogActions>

        </Dialog>
    );
}


const useStyles = makeStyles(() => ({

    dialogContainer: {
        width: "100%",
        margin: "auto",

        height: "100% !important",
        '& .MuiDialog-paper': {
            overflowY: "unset",
            height: "80%",
        },
    },
    buttons: {
        width: "100%",
        textAlign: "center"
    },
    okButton: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        backgroundColor: FlagstoneTheme.palette.primary.main,
        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
        },
        margin: "3px",
        width: "50px",
        marginBottom: "20px",
        position: "relative",
    },
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        '& h2': {
            fontSize: "32px !important",
        },
        paddingTop: "0px"
    },
    dialogContext: {
        color: "#000000",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center"
    },
    document: {
        height: "100%",
        overflowY: "auto",
        overflowX: "hidden"
    },
    noDoc:{
        height: "100%",
        overflowY: "auto",
        overflowX: "hidden",
        padding:"20px"
    }

}));
